import React from 'react';
import useLiveValue from '../useLiveValue';
import useMeterField from '../useMeterField';

const EnergyFlowWidget = ({ config }) => {
    const { settings = {}, title } = config;
    const max = settings.max ?? 100;
    const isPreview = typeof config.id === 'string' && config.id.startsWith('preview-');
    const report = useMeterField(title, { meterId: settings.meterId, skip: isPreview });
    const liveValue = useLiveValue(settings.value ?? 0, { id: config.id, endpoint: report.field ? 'report' : '', min: 0, max });
    const value = report.field ? (report.latest ?? 0) : liveValue;
    const accent = settings.color || '#4318FF';
    const pct = max > 0 ? Math.min(1, Math.max(0, value / max)) : 0;
    const loadValue = Number((value * 0.94).toFixed(1));
    const speed = Math.max(0.6, 2.2 - pct * 1.6);

    return (
        <div
            className="energy-flow-widget"
            title={`${value}${settings.unit || ''} generated → ${loadValue}${settings.unit || ''} delivered`}
        >
            <svg viewBox="0 0 300 100" className="energy-flow-widget__svg" preserveAspectRatio="xMidYMid meet">
                <path d="M40,50 L150,50" className="energy-flow-widget__line" style={{ stroke: accent, animationDuration: `${speed}s` }} />
                <path d="M150,50 L260,50" className="energy-flow-widget__line" style={{ stroke: accent, animationDuration: `${speed}s` }} />
                <circle cx="40" cy="50" r="22" className="energy-flow-widget__node" style={{ stroke: accent }} />
                <circle cx="150" cy="50" r="16" className="energy-flow-widget__node energy-flow-widget__node--grid" />
                <circle cx="260" cy="50" r="22" className="energy-flow-widget__node" style={{ stroke: accent }} />
                <text x="40" y="24" textAnchor="middle" className="energy-flow-widget__label">Generation</text>
                <text x="150" y="20" textAnchor="middle" className="energy-flow-widget__label">Grid</text>
                <text x="260" y="24" textAnchor="middle" className="energy-flow-widget__label">Load</text>
                <text x="40" y="55" textAnchor="middle" className="energy-flow-widget__value">{value}</text>
                <text x="260" y="55" textAnchor="middle" className="energy-flow-widget__value">{loadValue}</text>
            </svg>
            <div className="energy-flow-widget__unit">{settings.unit || 'kW'}</div>
        </div>
    );
};

export default EnergyFlowWidget;
